import Info from "./Info";
import Tags from "./Tags";
import FileUpload from "./FileUpload";
export default {
    Info,
    Tags,
    FileUpload,
}